import multiply from "./multiply.js";
import reduce from "./reduce.js";
/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */

var product =
/*#__PURE__*/
reduce(multiply, 1);
export default product;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/product.js
// module id = 1388
// module chunks = 1